import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SubmissionError } from 'redux-form';
import qs from 'qs';

import { recoverUserPassword } from '../../actions';
import PasswordReset from '../../components/password-reset/form';
import PasswordResetConfirmation from '../../components/password-reset/confirmation';
import { reportError } from '../../../lib/error-reporter';
const env = global.pbgEnv;
const { REACT_APP_BUSINESS_URL } = env;

const COMPONENT_ID = 'DesktopPasswordResetFormContainer';
class PasswordResetContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectTo: null,
      email: null,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onLoginClick = this.onLoginClick.bind(this);
    this.onSendAgainClick = this.onSendAgainClick.bind(this);
  }

  onLoginClick() {
    if (window.location.search === '?referrer=business') {
      this.setState({ redirectTo: REACT_APP_BUSINESS_URL });
    } else {
      const query = qs.parse(window.location.search.substring(1));

      const loginLink = query.redirect ? `/login?redirect=${query.redirect}` : "/login";
      this.setState({ redirectTo: loginLink });
    }
  }

  onSendAgainClick() {
    this.setState({ email: null });
  }

  onSubmit({ email }) {
    return this.props.actions.recoverUserPassword({ email }, email)
      .then(() => this.showConfirmation(email))
      .catch((error) => {
        reportError({
          error,
          component: COMPONENT_ID,
          params: { email },
        });

        throw new SubmissionError({
          _error: error.message,
        });
      });
  }

  showConfirmation(email) {
    this.setState({ email });
  }

  redirect() {
    window.location = this.state.redirectTo;
    return null;
  }

  renderConfirmation() {
    return (
      <PasswordResetConfirmation
        email={this.state.email}
        onSendAgainClick={this.onSendAgainClick}
      />
    );
  }

  renderForm() {
    return (
      <PasswordReset
        onSubmit={this.onSubmit}
        onLoginClick={this.onLoginClick}
      />
    );
  }

  render() {
    if (this.state.redirectTo) return this.redirect();
    if (this.state.email) return this.renderConfirmation();
    return this.renderForm();
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({
      recoverUserPassword,
    }, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(PasswordResetContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/password-reset/form.container.js